// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__dnhd-","label":"Radio_label__1hCKi","checkMark":"Radio_checkMark__2R7JO","disabled":"Radio_disabled__3mECA"};